import React, { Component } from "react";
import HttpServices from "../../utils/Http.services";
import { checkTextTranslation, checkTranslation, imageAddress, translate } from "../../utils/useful";
import Dashboard from "./Dashboard";
import Loader from 'react-loader-spinner'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import Cookies from "universal-cookie";

class DashboardsContainer extends Component {

    state = {
        portals: [
            { label: '{{lang}}Messenger', notif: 5, window: 'messenger', icon: '/assets/icons/portals/chat (2).png', description: '{{lang}}Keep in touch with people matter to you', key: 'Messenger' },
            { label: '{{lang}}Drive', window: 'drive', icon: '/assets/icons/portals/files.png', description: '{{lang}}Keep your files safe and secure in Yonnect cloud', key: 'Drive' },
            { label: '{{lang}}Rooms', window: 'rooms', icon: '/assets/icons/portals/video-calling (1).png', description: '{{lang}}Video and voice rooms. Enjoy custom rooms', key: 'Rooms' },
            { label: '{{lang}}Desk', notif: 20, window: 'desk', icon: '/assets/icons/portals/note.png', description: '{{lang}}Track your tasks and plans all in yonnect Desk', key: 'Desk' },
            { label: '{{lang}}Email', window: 'email', icon: '/assets/icons/portals/email.png', description: '{{lang}}Enjoy social connection with people and ideas', key: 'Email' },
            // { label: '{{lang}}Notebook', window: 'notebook', icon: '/assets/icons/Notebook.svg', description: '{{lang}}Keep all your notes and whiteboards here', key: 'Notebook' },
            { label: '{{lang}}Calendar', window: 'calendar', icon: '/assets/icons/portals/calendar.png', description: '{{lang}}check your calendar', key: 'Calendar' },
        ],
        currentDashboard: {},
        dashboards: [],
        hubs: [
            // { icon: '/images/p1.png', name: 'Pouya Pezhman', notif: '4', },
            // { icon: '/images/p2.png', name: 'Pedram Pezhman', notif: '4', },
            // { icon: '/images/p3.png', name: 'Hossein Mohseni', notif: '4', },
            // { icon: '/images/p4.png', name: 'Parna Azizi', notif: '4', },
            // { icon: '/images/p5.png', name: 'Shahrzad Serajpour', notif: '4', },
            // { icon: '/images/p6.png', name: 'Pouya Pezhman', notif: '4', },
            // { icon: '/images/p7.png', name: 'Pedram Pezhman', notif: '4', },
            // { icon: '/images/p8.png', name: 'Hossein Mohseni', notif: '4', },
            // { icon: '/images/p1.png', name: 'Pouya Pezhman', notif: '4', },
            // { icon: '/images/p2.png', name: 'Pedram Pezhman', notif: '4', },
            // { icon: '/images/p3.png', name: 'Hossein Mohseni', notif: '4', },
            // { icon: '/images/p4.png', name: 'Parna Azizi', notif: '4', },
            // { icon: '/images/p5.png', name: 'Shahrzad Serajpour', notif: '4', },
            // { icon: '/images/p6.png', name: 'Pouya Pezhman', notif: '4', },
            // { icon: '/images/p7.png', name: 'Pedram Pezhman', notif: '4', },
            // { icon: '/images/p8.png', name: 'Hossein Mohseni', notif: '4', },
        ],
    }

    componentDidMount() {
        this.waitForToken(10)
        // const cookies = new Cookies();
        // let token = cookies.get('token');
        // if (token) {
        //     console.log('foundTOKEN2')
        //     this.setState({ isLoading: true })
        //     this.waitForId(10)
        //     this.portalsContainer.addEventListener('wheel', this.onWheel, true)
        // } else {
        //     console.log('notfoundTOKEN2')
        // }
    }
    // componentDidUpdate = (prevProps) => {
    //     // console.log('this.props.user?.loggedin',this.props.user?.loggedin)
    //     // console.log('prevProps.user?.loggedin',prevProps.user?.loggedin)
    //     // if (this.props.user?.loggedin && this.props.user?.loggedin != prevProps.user?.loggedin) {
    //     //     console.log('hereFoundUserChanges')
    //     //     this.waitForId(10)
    //     // }
    // }
    waitForToken = (leftAttempt) => {
        const cookies = new Cookies();
        let token = cookies.get('token');
        if (token) {
            this.setState({ isLoading: true })
            this.waitForId(10)
            if (this.portalsContainer) {
                this.portalsContainer.addEventListener('wheel', this.onWheel, true)
            }

        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForToken(leftAttempt - 1)
                } else {
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }
    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {
            // console.log('userfound', true)
            this.setState({ isLoading: false }, () => {
                this.fetchDashboards()
            })
        } else {
            // console.log('userfound', false, leftAttempt)
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }

    componentWillUnmount() {
        this.portalsContainer.removeEventListener('wheel', this.onWheel)
    }

    onWheel = (e) => {
        if (Math.abs(e.deltaX) >= Math.abs(e.deltaY)) {
            e.stopPropagation()
        }
    }

    fetchDashboards = () => {
        this.setState({ isLoadingData: true })
        HttpServices.request('getMyDashboards', {}, (fetchResult, fetchError) => {
            this.setState({ isLoadingData: false })
            if (fetchError) {
                this.setState({ pageStatus: 404 })
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            let dashboards = []
            if (fetchResult.info) {
                dashboards = fetchResult.info
            }

            // console.log(dashboards)
            this.setState({ pageStatus: 200, dashboards }, () => {
                this.setState({ currentDashboard: this.state.dashboards[0] })
                // let initTab = this.state.tabs[0]
                // this.stageManager.changeStage(initTab.key)
                // this.setState({ currentTab: initTab.key })
            })
        })
    }

    changeDashboard = (prop) => {
        let currentDashboard = this.state.currentDashboard
        if (prop == 'default') {
            currentDashboard = this.state.dashboards[0]
        }
        else {
            currentDashboard = prop
        }
        this.setState({ currentDashboard })
    }

    postDashboard = (_id, name, pages, cb) => {
        let data = {
            _id: _id,
            name: name,
            // type: 'page',
            page: pages,
        }
        let isEditing = data._id ? true : false
        let address = 'postDashboard'
        // data.page = this.props.page?.key
        this.setState({ isPostingData: true })
        for (const [key, value] of Object.entries(data)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                delete data[key]
            }
        }
        // data.frame = this.state.currentFrame?._id
        // data.features = this.props.applet.features
        data.name = name
        // return
        HttpServices.request(address, data, (fetchResult, fetchError) => {
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postFailed', description: fetchError.message })
                return
            }
            let dashboards = this.state.dashboards ?? []
            dashboards.push(fetchResult.info)
            this.setState({ dashboards })
            cb(fetchResult)
        })
    }

    addNewDashboard = () => {
        let path = []
        path.push('settings')
        path.push('dashboards')
        path.push('new')
        this.props.addNewWindow('', { path: path, postDashboard: this.postDashboard })
    }

    goToDashboardPage = (item) => {
        let path = []
        path.push('settings')
        path.push('dashboards')
        path.push(item._id)
        this.props.addNewWindow('', { path: path, postDashboard: this.postDashboard })
        // this.props.addNewWindow()
    }

    openDashboards = () => {
        let path = []
        path.push('settings')
        path.push('dashboards')
        this.props.addNewWindow('', { path: path, postDashboard: this.postDashboard })
    }

    render() {
        let canScroll = this.props.canScroll
        return (
            <div ref={el => this.main = el} className="Dashboard no-scrollbar " style={{ backgroundColor: '#f5f5f5', top: this.props.dashboardPos, overflow: canScroll ? 'auto' : 'hidden' }}>
                {this.props.user.loggedin && (
                    <div ref={el => this.portalsContainer = el} className="portals-container d-flex pt-2 overflow-auto sc-gray2"   >
                        {this.state.portals.map((item, index) => {
                            // console.log('this.props.inbox',this.props.inbox)
                            let notifCount = this.props.inbox.categorizer[item?.key.toLowerCase()]?.count
                            return (
                                <div key={index} className="portal-item  flex-1 ">
                                    <div className="portal-item-container px-3 pt-2 pb-3 d-flex" onClick={() => this.props.addNewWindow(item.window)}>
                                        <img className="mt-1" src={item.icon} style={{ height: 40 }} />
                                        <div className="mld-3">
                                            <div className="flexcb">
                                                <p className="text-semibold text-normal my-0">{checkTranslation(item.label)}</p>
                                                {notifCount > 0 && (
                                                    <div className="portal-notif flexcc">{notifCount < 999 ? notifCount : '+999'}</div>
                                                )}
                                            </div>
                                            <p className="text-smallest mt-0">{checkTranslation(item.description)}</p>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                )
                    //  : (
                    //     <div ref={el => this.portalsContainer = el} className="portals-container d-flex pt-2"  >
                    //         {this.state.portals.map((item, index) => {
                    //             return (
                    //                 <div key={index} className="portal-item  flex-1" >
                    //                     <div className="portal-item-container px-3 pt-2 pb-3 d-flex" onClick={() => this.props.addNewWindow(item.window)}>
                    //                         <div className='skeleton-box  mt-1' style={{ width: 68, height: 50, backgroundColor: '#dedede', borderRadius: 50 }}></div>
                    //                         <div className="mld-3 w-100 flexcc flex-column">
                    //                             <div className="flexc w-100">
                    //                                 <div className='skeleton-box br-15 mt-1' style={{ width: '40%', height: 15, backgroundColor: '#dedede', }}></div>
                    //                             </div>
                    //                             <div className='skeleton-box br-15 mt-2' style={{ width: '100%', height: 15, backgroundColor: '#dedede', }}></div>
                    //                             {/* <div className='skeleton-box br-15 mt-1' style={{ width: '70%', height: 18, backgroundColor: '#dedede', }}></div> */}
                    //                         </div>
                    //                     </div>
                    //                 </div>
                    //             )
                    //         })}
                    //     </div>
                    // )
                }

                <div className=" flexc py-2 mt-2 px-4 position-sticky top-0 " style={{ zIndex: 3, backgroundColor: '#f6f6f6', }}>
                    <button onClick={() => { this.openDashboards() }}>
                        <p className="text-big text-bold mrd-4">{translate("Dashboards")}</p>
                    </button>
                    <div className="flexc sc-gray2 py-1" style={{ overflowX: 'auto' }}>
                        <button onClick={() => this.addNewDashboard()} className="mrd-3 p-1" style={{ background: '#e0e0e0', borderRadius: 30 }}>
                            <img src="/assets/icons/plus-gray.svg" width={22} className="flexcc" />
                        </button>
                        {/* <button onClick={() => this.changeDashboard('default')} className={"mrd-3 br-8 px-3 py-2" + (this.state.currentDashboard._id == 'default' ? '' : '')} style={{ background: this.state.currentDashboard._id == 'default' ? 'linear-gradient(to right, rgb(124, 122, 255), rgb(88, 86, 214))' : 'linear-gradient(to right, #eee, #eee)', }}>
                            <p className={" flexcc weight-600 text-smaller  " + (this.state.currentDashboard._id == 'default' ? 'white' : 'main-c7')}>{translate('Default')}</p>
                        </button> */}
                        {/* {console.log('this.state.dashboards', this.state.dashboards)} */}
                        {this.state.dashboards.map((item, index) => {
                            return (
                                <button onClick={() => this.changeDashboard(item)} key={index} className={"mrd-3 br-20 px-1 py-1" + (this.state.currentDashboard._id == item._id ? '' : '')} style={{ height: 34, background: this.state.currentDashboard._id == item._id ? 'linear-gradient(to right, rgb(124, 122, 255), rgb(88, 86, 214))' : 'linear-gradient(to right, #e0e0e0, #e0e0e0)', }}>
                                    <div className="flexcb">
                                        <p className={"px-3 flexcc weight-600 font-size-13 my-0 " + (this.state.currentDashboard._id == item._id ? 'white' : 'main-c7')}>{checkTranslation(item.name)}</p>
                                        {(this.state.currentDashboard._id == item._id) &&
                                            <div className="br-20 flexcc" style={{ backgroundColor: '#10101040', height: 26, width: 26 }} onClick={(e) => { e.stopPropagation(); this.goToDashboardPage(item) }}>
                                                <img src="/assets/icons/useful/setting-1.png" width={15} className="flexcc invert" />
                                            </div>
                                        }
                                    </div>
                                </button>
                            )
                        })}
                    </div>
                </div>
                {this.state.isLoadingData && (
                    <div className="flexcc pt-5">
                        <Loader
                            type={"Grid"}
                            color={"#ddd"}
                            height={40}
                            width={40}
                        />
                    </div>
                )}

                <Dashboard addNewWindow={this.props.addNewWindow} data={this.state.currentDashboard} width={this.props.width} />
            </div>
        )
    }
};




const mapStateToProps = state => ({ settings: state.settings, user: state.user, connection: state.connection, inbox: state.inbox, relations: state.relations })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(DashboardsContainer);

